<template>
    <div v-if="Object.keys(assinaturas).length > 0" class="card flex-container my-4">
        <div class="flex gap-2">
            <h3 class="font-semibold">{{ assinaturas.descricao != '' ? assinaturas.descricao : 'Assinaturas' }}</h3>
            <Status :status="statusResposta" />
        </div>
        <div class="mt-4" v-for="(assinatura, id) in assinaturas.opcoes" :key="id">
            <p class="mb-1">{{ assinatura }}</p>
            <button v-if="!assinaturas.respostas || !assinaturas.respostas.hasOwnProperty(id)" @click="assinar(id)"
                class="block w-full bg-cinza-desabilitado border border-cinza-habilitado rounded p-4 mb-4 shadow-md h-12 flex items-center justify-center font-semibold">
                <Icone :nome="'signature'" />
                Assinar
            </button>
            <div v-else>
                <p>
                    <span class="font-medium">Nome: </span>
                    {{ assinaturas.respostas[id].signatario != '' ? assinaturas.respostas[id].signatario : '-' }}
                </p>
                <p>
                    <span class="font-medium">Documento: </span>
                    {{ assinaturas.respostas[id].numeroDocumento != '' ? assinaturas.respostas[id].numeroDocumento : '-' }}
                </p>
                <p v-if="assinaturas.respostas[id].ciente">
                    <span class="font-medium">Informações confirmadas: </span>
                    Sim
                </p>
                <div
                    class="cursor-pointer flex justify-center items-center landscape:flex-row border border-2 rounded-lg">
                    <img class="w-full h-56 assinaturas" :src="assinaturas.respostas[id].imagem" alt="Imagem assinatura">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import Icone from '@/components/Icone.vue';
import Status from '@/components/Status.vue';
import FuncoesHelper from '@/helpers/FuncoesHelper';
import ComponenteAssinaturaService from '@/services/componentes/ComponenteAssinaturaService';

export default defineComponent({
    name: 'Assinatura',
    props: {
        modulo: {
            type: String,
            required: true
        }
    },
    components: {
        Icone,
        Status
    },
    methods: {
        assinar(idAssinante) {
            FuncoesHelper.pushRouter('DetalheAssinatura', { identificador: this.identificador, signatario: idAssinante })
        }
    },
    setup(props) {
        return ComponenteAssinaturaService.setup(props)
    }
})
</script>